import{n as e,r as i,y as t}from"../../../493beda6.js";customElements.define("cai-icon-twitter",class extends e{static get styles(){return i`
      :host {
        display: inline-block;
        width: var(--cai-icon-width, 16px);
        height: var(--cai-icon-height, 16px);
      }

      svg {
        width: 100%;
        height: 100%;
        fill: var(--cai-icon-fill, currentColor);
      }

      path {
      }
    `}render(){return t`<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
      part="svg"
    >
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          d="M23.206 5.185c-.835.37-1.732.62-2.675.733a4.67 4.67 0 0 0 2.048-2.578 9.3 9.3 0 0 1-2.958 1.13 4.66 4.66 0 0 0-7.938 4.25 13.229 13.229 0 0 1-9.602-4.868c-.4.69-.63 1.49-.63 2.342a4.66 4.66 0 0 0 2.072 3.878 4.647 4.647 0 0 1-2.11-.583v.06a4.66 4.66 0 0 0 3.737 4.568 4.692 4.692 0 0 1-2.104.08 4.661 4.661 0 0 0 4.352 3.234 9.348 9.348 0 0 1-5.786 1.995A9.5 9.5 0 0 1 .5 19.361a13.175 13.175 0 0 0 7.14 2.093c8.57 0 13.255-7.098 13.255-13.254 0-.2-.005-.402-.014-.602a9.47 9.47 0 0 0 2.323-2.41l.002-.003Z"
          fill="#1DA1F1"
          fill-rule="nonzero"
        />
      </g>
    </svg>`}});
